module.exports = __webpack_public_path__ + "img/safari.90ee81c2.png";